import { api } from '../core/api';
import {
  Asset,
  AssetDashboardSetting,
  GetPlannedQtyForAssetRequest,
  PerformanceRequest,
  QtyForAsset,
  Shift,
} from '../../types/app/asset.types';

export const getAssetList = (id?: number) =>
  id
    ? api.get<Asset[]>(`Asset/GetList?parentId=${id}`).then((res) => res.data)
    : api.get<Asset[]>('Asset/GetList').then((res) => res.data);

export const getListFiltered = (groupId?: number, parentId?: number) =>
  api
    .get<Asset[]>(
      groupId === undefined
        ? `Asset/GetListFiltered`
        : `Asset/GetListFiltered` +
            (groupId ? `?groupId=${groupId}` : '') +
            (parentId ? `&parentId=${parentId}` : ''),
    )
    .then((res) => res.data);

export const getListWithDashboardsFiltered = (groupId?: number) =>
  api
    .get<Asset[]>(
      groupId === undefined
        ? `Asset/GetListWithDashboardsFiltered`
        : `Asset/GetListWithDashboardsFiltered` + (groupId ? `?groupId=${groupId}` : ''),
    )
    .then((res) => res.data);

export const getAsset = (id: number) =>
  api.get<Asset>(`Asset/GetItem?id=${id}`).then((res) => res.data);

export const assetGetTreeView = (id: number) =>
  api.get(`Asset/AssetGetAssetTreeView?id=${id}`).then((res) => res.data);

export const getShiftsForAsset = (id: number) =>
  api.get<Shift[]>(`Asset/GetShiftsForAsset?id=${id}`).then((res) => res.data);

export const getCurrentShiftForAsset = (id: number) =>
  api.get<Shift>(`Asset/GetCurrentShiftForAsset?id=${id}`).then((res) => res.data);

export const getMainDashBoardSettingForAsset = (id: number) =>
  api
    .get<AssetDashboardSetting>(`Asset/GetMainDashBoardSettingForAsset?id=${id}`)
    .then((res) => res.data);

export const getAssetPlannedQtyForAsset = (plannedQty: GetPlannedQtyForAssetRequest) =>
  api
    .get<QtyForAsset[]>(
      `Asset/AssetGetPlannedQtyForAsset?id=${plannedQty.id}&from=${plannedQty.dateFrom}&to=${plannedQty.dateTo}`,
    )
    .then((res) => res.data);

export const getPerformance = (request: PerformanceRequest) =>
  api
    .get<any>(
      `Asset/GetPerformance?assetId=${request.assetId}&machine=${request.machine}&from=${request.dateFrom}&to=${request.dateTo}&aggregation=${request.aggregation}&dataId=${request.dataId}`,
    )
    .then((res) => res.data);

export const getCount = (topOnly: boolean) =>
  api.get<number>(`Asset/GetCount?topOnly=${topOnly}`).then((res) => res.data);
